import { addMessages } from 'svelte-i18n';
import it from '../assets/i18n/it.json';
import en from '../assets/i18n/en.json';
addMessages('it', it);
addMessages('en', en);
